/* eslint react/prefer-stateless-function: "off" */
/* eslint jsx-a11y/label-has-for: "off" */
/* eslint class-methods-use-this: "off" */
/* eslint no-console: "off" */
/* eslint jsx-a11y/alt-text: "off" */
/* eslint react/prop-types: "off" */
import React, { Component } from 'react';
// import { withSize, sizeMe } from 'react-sizeme';
import sizeMe from 'react-sizeme';

import './style.css';

const isHorizontal = (orientation = 'horizontal') => orientation === 'horizontal';
const rgbaColor = (color = {}) => `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`;

// .scene {
//   border: 1px solid #CCC;
//   margin: 40px 0;
//   position: relative;
//   width: 210px;
//   height: 140px;
//   margin: 80px auto;
//   perspective: 1000px;
// }

const CarouselScene = (props) => {
  const { monitorHeight, backgroundColor, ...rest } = props;
  const style = {
    border: '1px solid #CCa',
    position: 'relative',
    perspective: '6000px',
    flex: 1,
    overflow: 'hidden',
    backgroundColor: rgbaColor(backgroundColor),
  };

  return (<div {...rest} style={style} />);
};

const SizedCarouselScene = sizeMe({ monitorHeight: true })(CarouselScene);

// .carousel {
//   width: 100%;
//   height: 100%;
//   position: absolute;
//   transform: translateZ(-288px);
//   transform-style: preserve-3d;
//   transition: transform 1s;
// }
const CarouselOuter = (props) => {
  const { size = {}, children } = props;
  const outerWidth = (size.width || 0) * 0.4;
  const outerHeight = (size.height || 0) * 0.6;
  const style = {
    // background: '#fa1',
    position: 'relative',
    height: `${outerHeight}px`,
    width: `${outerWidth}px`,
    // margin: '0px auto',
  };
  return (
    <div className="h-full mx-auto my-auto CarouselOuter" style={style}>
      { children }
    </div>
  );
};

const SizedCarouselOuter = sizeMe({ monitorHeight: true })(CarouselOuter);


const CarouselInner = (props) => {

  const { cellCount, selectedIndex = 0 } = props.state;
  const theta = 360 / cellCount;

  const rotateFunc = isHorizontal(props.orientation) ? 'rotateY' : 'rotateX';
  const angle = theta * selectedIndex * -1;
  // const angle = index * theta;

  // ATETION: removed translateZ
  const { size = {} } = props;
  const cellSize = isHorizontal(props.orientation) ? size.width : size.height;
  // console.log('cellSize (2)', cellSize, size);
  const radius = Math.round((cellSize / 2) / Math.tan(Math.PI / cellCount));
  // const radius = -500;
  const transform = `translateZ(${-radius}px) ${rotateFunc}(${angle}deg)`;  

  const style = {
    transform,
    transformStyle: 'preserve-3d',
    transition: 'transform 1s',
  };
  return (
    <div className="w-full h-full" style={style} {...props} />
  );
};

const CarouselItemTitle = (props) => {
  const { overlayColor, textColor, ...rest } = props;
  const style = {
    backgroundColor: rgbaColor(overlayColor),
    color: rgbaColor(textColor),
  };
  return (
    <div className="absolute bottom-0 w-full mx-auto text-white" style={style} {...rest} />
  );
};

CarouselItemTitle.defaultProps = {
  // backgroundColor: 'rgba(28, 157, 190, 0.7)',
  overlayColor: {
    r: 28, g: 157, b: 190, a: 0.7,
  },
  // textColor: 'rgba(255, 255, 255, 1)',
  textColor: {
    r: 255, g: 255, b: 255, a: 1,
  },
};

const CarouselItemMedia = (props) => {
  return (
    <img className="object-contain overflow-hidden CarouselItemMedia" {...props} />
  );
};

const nChildStyles = [
  { background: 'hsla(  0, 100%, 50%, 0.8)' },
  { background: 'hsla( 40, 100%, 50%, 0.8)' },
  { background: 'hsla( 80, 100%, 50%, 0.8)' },
  { background: 'hsla(120, 100%, 50%, 0.8)' },
  { background: 'hsla(160, 100%, 50%, 0.8)' },
  { background: 'hsla(200, 100%, 50%, 0.8)' },
  { background: 'hsla(240, 100%, 50%, 0.8)' },
  { background: 'hsla(280, 100%, 50%, 0.8)' },
  { background: 'hsla(320, 100%, 50%, 0.8)' },
];

const CarouselCell = (props) => {
  const { sceneSize = {} } = props;
  const { cellCount } = props.state;
  const { size = {}, children } = props;
  const theta = 360 / cellCount;
  const cellSize = isHorizontal(props.orientation) ? (size.width || 0) : (size.height || 0);
  const radius = Math.round((cellSize / 2) / Math.tan(Math.PI / cellCount));
  const { index = 0 } = props;
  const rotateFunc = isHorizontal(props.orientation) ? 'rotateY' : 'rotateX';
  const angle = index * theta;
  const transform = `${rotateFunc}(${angle}deg) translateZ(${radius}px)`;
  const childStyle = nChildStyles[index % 9];

  const style = {
    position: 'absolute',
    width: `${cellSize - 5}px`,
    maxHeight: `${sceneSize.height}px`,
    border: '2px solid black',
    lineHeight: '20px',
    fontWeight: 'bold',
    color: 'white',
    textAlign: 'center',
    transition: 'transform 1s, opacity 1s',
    transform: index < cellCount ? transform : 'none',
    opacity: index < cellCount ? 1 : 0, // hide out of box slides
    ...childStyle,
  };
  return (
    <div style={style}>
      { children }
    </div>
  );
};

class Carousel3D extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: 0,
      cellCount: 9,
    };
    this.timer = this.timer.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    // this.setState({ mounted: true });

    if ((this.props.items && this.props.items.length > 1) && (this.state.autoplay > 0)) {
      // console.log('componentDidMount', 'registerTimer', this.props.items, this.state.autoplay);
      setTimeout(() => this.registerTimer(), 0);
    } else {
      // console.log('componentDidMount', 'unregisterTimer', this.props.items, this.state.autoplay);
      this.unregisterTimer();
    }
  }

  componentWillReceiveProps(nextProps) {
    // console.log('componentWillReceiveProps');
    const { reverseDirection = false } = nextProps;
    const { autoplay: propsAutoplay = 0 } = nextProps;
    const autoplay = parseInt(propsAutoplay, 10);
    if (reverseDirection !== this.state.isReversing) {
      this.setState({ isReversing: reverseDirection });
    }
    const safeAutoplay = (autoplay || 0) && Math.max(autoplay || 0, 1000);

    if (!safeAutoplay) {
      this.unregisterTimer();
    } else if (parseInt(autoplay, 10) === 0) {
      this.unregisterTimer();
    }
    if (nextProps.items && nextProps.items.length <= 1) {
      // console.log('FlexCarousel autoplay unregister timer', this.props.position);
      this.unregisterTimer();
    } else {
      // console.log('playing...', this.mounted);
      // console.log('nextProps', nextProps);
      this.unregisterTimer();
      this.setState({ autoplay: safeAutoplay });
      if (safeAutoplay) {
        setTimeout(() => this.registerTimer('WillReceiveProps 283'), 0);
      }
    }
    // return true;
  }

  componentWillUnmount() {
    // use intervalId from the state to clear the interval
    // clearInterval(this.state.intervalId);
    // console.log('componentWillUnmount');
    this.unregisterTimer();
    this.mounted = false;
  }

  timer() {
    if (this.props.autoplay) {
      if (this.state.isReversing) {
        this.prev();
      } else {
        this.next();
      }
    }
  }

  registerTimer(/* context */) {
    // console.log('registerTimer', context, this.mounted);
    this.unregisterTimer();
    if (!this.mounted) return;
    if (parseInt(this.state.autoplay, 10) !== 0) {
      if (this.props.items && this.props.items.length > 1) {
        const intervalId = setInterval(this.timer, this.state.autoplay);
        // console.log('registerTimer', intervalId);
        this.setState({ intervalId });
      }
    }
  }

  unregisterTimer() {
    // console.log('unregisterTimer', this.state.intervalId);
    clearInterval(this.state.intervalId);
  }

  prev() {
    const { selectedIndex = 0 } = this.state;
    this.setState({ selectedIndex: selectedIndex - 1 });
    // this.rotateCarousel();
    // console.log('prev');
  }

  next() {
    const { selectedIndex = 0 } = this.state;
    this.setState({ selectedIndex: selectedIndex + 1 });
    // this.rotateCarousel();
  }

  render() {
    const {
      items,
      orientation,
      showTitle = true,
      showDescription = true,
      backgroundColor,
    } = this.props;
    console.log('Carousel props', backgroundColor, rgbaColor(backgroundColor));
    return (
      <SizedCarouselScene
        id="SizedCarouselScene"
        monitorHeight
        onSize={size => this.setState({ size })}
        backgroundColor={backgroundColor}
      >
        <SizedCarouselOuter
          size={this.state.size}
          id="CarouselOuter"
          onSize={size => this.setState({ outerSize: size })}
          // onSize={size => console.log('onSize Outer', size)}
        >
          <CarouselInner
            id="CarouselInner"
            state={this.state}
            orientation={orientation}
            size={this.state.outerSize}
            className="py-4"
          >
            { items.map((slide, index) =>
              (
                <CarouselCell
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  index={index}
                  orientation={orientation}
                  count={this.state.cellCount}
                  size={this.state.outerSize}
                  sceneSize={this.state.size}
                  state={this.state}
                  style={{
                    overflow: 'hidden',
                    backgroundColor: rgbaColor(backgroundColor),
                  }}
                >
                  <CarouselItemMedia src={slide.url || slide.photoURL} />
                  <CarouselItemTitle >
                    { showTitle && (<h2>{slide.title}</h2>) }
                    { showDescription && (<p>{slide.description}</p>) }
                  </CarouselItemTitle>
                </CarouselCell>))
            }
          </CarouselInner>
        </SizedCarouselOuter>
      </SizedCarouselScene>
    );
  }
}
// export default withSize()(Carousel3D);
export default Carousel3D;

// changeCarousel() {
//   // const { cellCount, isHorizontal } = this.state;
//   // const theta = 360 / cellCount;
//   // const { size } = this.props;
//   // const cellSize = isHorizontal ? size.width : size.height;
//   // const radius = Math.round((cellSize / 2) / Math.tan(Math.PI / cellCount));
//   // console.log('changeCarousel', this.state.cellCount, this.state.orientation, this.props.size, radius);
// }
// function onOrientationChange() {
//   var checkedRadio = document.querySelector('input[name="orientation"]:checked');
//   isHorizontal = checkedRadio.value == 'horizontal';
//   rotateFn = isHorizontal ? 'rotateY' : 'rotateX';
//   changeCarousel();
// }
// onOrientationChange(event) {
//   const orientation = event.target.value;
//   // const isHorizontal = orientation === 'horizontal';
//   // const rotateFn = isHorizontal ? 'rotateY' : 'rotateX';
//   this.setState({ orientation });
//   this.changeCarousel();
// }
// rotateCarousel() {
//   console.log('rotateCarousel', this.state.selectedIndex);
// }



// WEBPACK FOOTER //
// ./src/lab/components/Carousel3D/index.js